import React, { useState, useEffect } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import Styles from '../../pages/cars/Car.module.css';
import Card from '../../pages/cars/Card';

// სურათების იმპორტი


import Micra from '../../images/cars/micra.png';
import Yaris from '../../images/cars/yaris.png';
import Logan from '../../images/cars/logan.png';
import Corolla from '../../images/cars/corolla.png';
import Sandero from '../../images/cars/sandero.png';
import Daster from '../../images/cars/daster.jpg';
import Tucson from '../../images/cars/tucson.avif';
import Prado from '../../images/cars/prado.png';
import Fortuner from '../../images/cars/fortuner.png';
import Rav4 from '../../images/cars/Rav4_2021.jpg';
import Creta from '../../images/cars/creta.jpg';


const carsData = [
  {
    id: 1,
    model: 'Nissan Micra',
    group: 'Group_A',
    people: '4 People',
    fuel: 'petrol',
    bag: '1',
    transmission: 'Automatic',
    price: 45,
    image: Micra, 
    link: '/nissan_micra'
  },
  {
    id: 2,
    model: 'Toyota Yaris',
    group: 'Group_B',
    people: '4 People',
    fuel: 'petrol',
    bag: '1',
    transmission: 'Automatic',
    price: 45,
    image: Yaris,
    link: '/toyoya_yarus'
  },
  {
    id: 3,
    model: 'Renault Logan',
    group: 'Group_C',
    people: '4 People',
    fuel: 'petrol',
    bag: '3',
    transmission: 'Automatic/Manual',
    price: 45,
    image: Logan,
    link: '/Renault_Logan'
  },
  {
    id: 4,
    model: 'Toyota Corolla',
    group: 'Group_D',
    people: '5 People',
    fuel: 'petrol',
    bag: '3',
    transmission: 'Automatic',
    price: 50,
    image: Corolla,
    link: '/Toyota_Corolla'
  },
  {
    id: 5,
    model: 'Renault Sandero',
    group: 'Group_P',
    people: '4 People',
    fuel: 'petrol',
    bag: '1',
    transmission: 'Automatic',
    price: 50,
    image: Sandero,
    link: '/Renault_Sandero'
  },
  {
    id: 6,
    model: 'Renault Duster',
    group: 'Group_F',
    people: '5 People',
    fuel: 'petrol',
    bag: '3',
    transmission: 'Manual',
    price: 70,
    image: Daster,
    link: '/Renault_daster'
  },
  {
    id: 7,
    model: 'Hyundai Tucson',
    group: 'Group_G',
    people: '5 People',
    fuel: 'petrol',
    bag: '4',
    transmission: 'Automatic',
    price: 80,
    image: Tucson,
    link: '/Hyundai_Tucson'
  },
  {
    id: 8,
    model: 'Toyota Rav4',
    group: 'Group_G',
    people: '5 People',
    fuel: 'petrol',
    bag: '4',
    transmission: 'Automatic',
    price: 80,
    image: Rav4,
    link: '/Rav_fore'
  },
  {
    id: 9, 
    model: 'Hyundai Creta',
    group: 'Group_G',
    people: '5 People',
    fuel: 'petrol',
    bag: '4',
    transmission: 'Automatic',
    price: 80,
    image: Creta,
    link: '/Hyundai_Creta'
  },
  {
    id: 10,
    model: 'Toyota Fortuner',
    group: 'Group_Q',
    people: '5 People',
    fuel: 'petrol',
    bag: '4',
    transmission: 'Automatic/Manual',
    price: 130,
    image: Fortuner,
    link: '/Toyota_Fortuner'
  },
  {
    id: 11,
    model: 'Toyota Prado',
    group: 'Group_H',
    people: '5 People',
    fuel: 'petrol',
    bag: '4',
    transmission: 'Automatic/Manual',
    price: 140,
    image: Prado,
    link: '/Toyota_Prado'
  }
];

const SearchResults = () => {
  const location = useLocation();
  const searchParams = location.state?.searchParams;
  
  const [selectedCar, setSelectedCar] = useState(null);
  const [similarCars, setSimilarCars] = useState([]);
  
  useEffect(() => {
    if (searchParams && searchParams.carModel) {
      // მოძებნეთ მომხმარებლის მიერ არჩეული მანქანა
      const foundCar = carsData.find(car => car.model === searchParams.carModel);
      setSelectedCar(foundCar);
      
      if (foundCar) {
        // მოძებნეთ მსგავსი ფასის მქონე მანქანები (+/- 20 ევრო)
        const minPrice = foundCar.price - 20;
        const maxPrice = foundCar.price + 20;
        
        const similar = carsData.filter(car => 
          car.id !== foundCar.id && 
          car.price >= minPrice && 
          car.price <= maxPrice
        );
        
        setSimilarCars(similar);
      }
    }
  }, [searchParams]);
  
  if (!searchParams || !selectedCar) {
    return (
      <div className={Styles.container}>
        <h2 className={Styles.section_title}>Car not found</h2>
        <p>Please go back and try searching again</p>
        <NavLink to="/">
          <button className={Styles.btn}>Return to main page</button>
        </NavLink>
      </div>
    );
  }
  
  return (
    <section className={Styles.featured_car} id="search_results">
      <div className={Styles.container}>
        <div className={Styles.title_wrapper}>
          <h2 className={Styles.section_title}>Searched Car</h2>
        </div>
        
        {/* <div className={Styles.booking_details}>
          <p><strong>ადგილმდებარეობა:</strong> {searchParams.pickupLocation} - {searchParams.returnLocation}</p>
          <p><strong>თარიღი:</strong> {searchParams.pickupDate} {searchParams.pickupTime} - {searchParams.returnDate} {searchParams.returnTime}</p>
        </div> */}
        
        <ul className={Styles.featured_car_list}>
          <Card
            image={selectedCar.image}
            model={selectedCar.model}
            group={selectedCar.group}
            People={selectedCar.people}
            fuel={selectedCar.fuel}
            bag={selectedCar.bag}
            transmission={selectedCar.transmission}
            price={selectedCar.price}
            link={selectedCar.link}
          />
        </ul>
        
        {similarCars.length > 0 && (
          <>
            <div className={Styles.title_wrapper}>
              <h2 className={Styles.section_title}>Similar Priced Cars</h2>
            </div>
            
            <ul className={Styles.featured_car_list}>
              {similarCars.map(car => (
                <Card
                  key={car.id}
                  image={car.image}
                  model={car.model}
                  group={car.group}
                  People={car.people}
                  fuel={car.fuel}
                  bag={car.bag}
                  transmission={car.transmission}
                  price={car.price}
                  link={car.link}
                />
              ))}
            </ul>
          </>
        )}
      </div>
    </section>
  );
};

export default SearchResults;